<template>
    <div>
        <h1 style="text-align:center;margin:0px;">
            文章專欄
        </h1>
        <div style="margin-top:10px ;" class='container'>
            <div class="card" v-for="item in article" :key="item.id" @click="goArticle_id(item.id)">
                <div class="card-image-holder">
                    <a href="javascript:;">
                        <img :src="item.img" alt="Image Description" class="card-image">
                    </a>
                </div>
                <div class="card-content">
                    <div class="card-header">
                        <h2 class="card-title ellipsis "><a href="javascript:;">{{ item.title }}</a></h2>
                    </div>
                    <span v-if="item.time" style="display: flex;line-height: 30px;align-items: center"><svg style="margin-right: 10px;" t="1708660049688" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4363" width="20" height="20">
                            <path
                                d="M511.914 63.99c-247.012 0-447.925 200.912-447.925 447.924s200.913 447.925 447.925 447.925 447.925-200.913 447.925-447.925S758.926 63.989 511.914 63.989z m0 831.687c-211.577 0-383.763-172.186-383.763-383.763 0-211.577 172.014-383.763 383.763-383.763s383.763 172.014 383.763 383.763-172.186 383.763-383.763 383.763z"
                                fill="#bfbfbf" p-id="4364"></path>
                            <path
                                d="M672.06 511.914H512.085v-223.79c0-17.718-14.277-32.167-31.995-32.167-17.717 0-31.994 14.45-31.994 32.167V544.08c0 17.717 14.277 31.994 31.994 31.994H672.06c17.718 0 32.167-14.277 32.167-31.994-0.172-17.89-14.621-32.167-32.167-32.167z"
                                fill="#bfbfbf" p-id="4365"></path>
                        </svg>{{ item.time }}</span>
                    <p class="card-text ellipsis">{{ item.desc }}</p>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {

        };
    },
    computed: {
        ...mapState('header', ['isarticle', 'article']),
    },
    watch: {},
    methods: {
        goArticle_id(id) {
            this.$router.push({ path: '/article/' + id });
        }
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped></style>
<style lang="scss" scoped src="./index.scss"></style>
